function spLegacyText(element, key, fallback) { return element.closest('.sparkle-pilot, .sparkle-legacy')?.getAttribute('data-sp-' + key) ?? fallback; }
(() => {
  function initialize() {
    document.querySelectorAll('.sparkle-legacy').forEach(root => {
      if (root.dataset.metalControlsReady) return;
      const colours = root.querySelector('[data-metal-colours]');
      if (!colours) return;
      root.dataset.metalControlsReady = 'true';
      function update() {
        const selected = root.querySelector('input[name^="pilot-metal"]:checked');
        const platinum = selected?.value === 'Platinum';
        colours.hidden = platinum;
        colours.disabled = platinum;
      }
      root.addEventListener('change', event => {
        if (event.target.matches('input[name^="pilot-metal"]')) update();
      });
      update();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

(() => {
  function initialize() {
    document.querySelectorAll('.sp-contact').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const dialog = section.querySelector('dialog');
      function open(channel) {
        if (typeof dialog.showModal !== 'function') return false;
        dialog.querySelectorAll('[data-qr-panel]').forEach(panel => { panel.hidden = panel.dataset.qrPanel !== channel; });
        dialog.querySelector('[data-contact-dialog-title]').textContent = channel === 'whatsapp' ? spLegacyText(section, 'text-0a06e7d515d0', 'Connect on WhatsApp') : spLegacyText(section, 'text-a9f27ad20868', 'Connect on Messenger');
        dialog.showModal();
        return true;
      }
      section.querySelectorAll('[data-qr-channel]').forEach(button => button.addEventListener('click', () => open(button.dataset.qrChannel)));
      section.querySelectorAll('[data-contact-channel]').forEach(link => link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        if (window.matchMedia('(pointer:fine) and (min-width: 768px)').matches && open(link.dataset.contactChannel)) event.preventDefault();
      }));
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();


(() => {
  function initialize() {
    document.querySelectorAll('.sparkle-legacy').forEach(root => {
      const button = root.querySelector('[data-request-quote]');
      if (!button || button.dataset.ready) return;
      button.dataset.ready = 'true';
      const dialog = root.querySelector('[data-quote-dialog]');
      const message = dialog.querySelector('[data-quote-message]');
      const text = dialog.querySelector('[data-quote-text]');
      const fallback = dialog.querySelector('[data-quote-fallback]');
      const engravingToggle = root.querySelector('[data-engraving-toggle]');
      const engravingInput = root.querySelector('[data-engraving-text]');
      function syncEngraving() {
        const enabled = engravingToggle.checked;
        root.querySelector('[data-engraving-field]').hidden = !enabled;
        engravingInput.disabled = !enabled;
        engravingToggle.setAttribute('aria-expanded', String(enabled));
      }
      if (engravingToggle) {
        engravingToggle.addEventListener('change', syncEngraving);
        syncEngraving();
      }
      function configuration() {
        const metal = root.querySelector('input[name^="pilot-metal"]:checked')?.value || spLegacyText(root, 'text-df12aeba9bb9', 'Not selected');
        const colour = root.querySelector('input[name="properties[Metal colour]"]:checked')?.value || spLegacyText(root, 'text-df12aeba9bb9', 'Not selected');
        const lines = [spLegacyText(root, 'text-a130e4d7e9fd', 'Hello, I would like a quote for this Sparkle design.'), '', root.querySelector('h1').textContent.trim(), spLegacyText(root, 'text-66d131947363', 'Reference: ') + root.dataset.reference];
        root.querySelectorAll('[data-legacy-option]').forEach(field => {
          if (field.disabled) return;
          const selected = field.querySelector('input:checked');
          if (selected) lines.push(field.dataset.legacyOption + ': ' + selected.value);
        });
        const ringSize = root.querySelector('[data-ring-size]')?.value.trim();
        if (root.querySelector('[data-ring-size]')) lines.push(ringSize ? spLegacyText(root, 'text-2bebca70a092', 'Ring size (US): ') + ringSize : spLegacyText(root, 'text-57f1dd347e52', 'Ring size: Sizing assistance requested'));
        if (engravingToggle?.checked) lines.push(spLegacyText(root, 'text-683a15e7cbff', 'Free engraving: ') + (engravingInput.value.trim() || spLegacyText(root, 'text-a8b64939b2e5', 'Requested — wording to be confirmed')));
        if (location.protocol === 'https:' || location.protocol === 'http:') lines.push(spLegacyText(root, 'text-20ea8d95c40e', 'Product: ') + location.origin + location.pathname);
        return lines.join('\n');
      }
      async function copy() {
        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text.value);
            return true;
          }
        } catch (_) { /* Offer the visible manual copy field when access is denied. */ }
        try {
          fallback.hidden = false;
          text.focus();
          text.select();
          return document.execCommand('copy') === true;
        } catch (_) { return false; }
      }
      async function copyAndReport() {
        const success = await copy();
        fallback.hidden = success;
        message.textContent = success ? spLegacyText(root, 'text-0b66f5de7684', 'Your selected configuration has been copied. Open WhatsApp and paste it into the chat to request your quote.') : spLegacyText(root, 'text-227882f1b0bc', 'Automatic copying is unavailable in this browser. Copy the details below, then open WhatsApp and paste them into the chat.');
        if (success) dialog.querySelector('[data-quote-whatsapp]').focus();
      }
      button.addEventListener('click', async () => {
        text.value = configuration();
        fallback.hidden = true;
        message.textContent = spLegacyText(root, 'text-ee241eadcaec', 'Copying your selected configuration…');
        dialog.showModal();
        await copyAndReport();
      });
      dialog.querySelector('[data-quote-copy]').addEventListener('click', copyAndReport);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

(() => {
  function refreshDelivery() {
    const parts = new Intl.DateTimeFormat('en-US', {timeZone:'Asia/Dubai',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date());
    const value = type => Number(parts.find(p => p.type === type).value);
    document.querySelectorAll('[data-delivery-date]').forEach(node => {
      const days = node.getAttribute('data-delivery-date') === 'end' ? 12 : 10;
      const arrival = new Date(Date.UTC(value('year'), value('month') - 1, value('day') + days));
      node.textContent = new Intl.DateTimeFormat('en-US', {timeZone:'UTC',month:'short',day:'numeric'}).format(arrival);
      node.setAttribute('datetime', arrival.toISOString().slice(0,10));
    });
  }
  refreshDelivery();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshDelivery(); });
  document.addEventListener('shopify:section:load', refreshDelivery);
  setInterval(refreshDelivery, 60000);
})();
